import { useEffect, useState } from "react";
import { Building2, Search, X } from "lucide-react";
import { DIREZ, DIREZ_NAME } from "./shared";
import api from "@/lib/api";

export function PartnerPicker({ value, label, onPick, testid, allowDirez = true }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return; }
    const t = setTimeout(() => api.get("/monitoring/partners-search", { params: { q } }).then((r) => setRes(r.data.partners)).catch(() => setRes([])), 250);
    return () => clearTimeout(t);
  }, [q]);
  if (value) return (
    <span className="inline-flex items-center gap-2 rounded-full border border-neutral-700 px-3 py-1 text-xs text-white" data-testid={`${testid}-current`}>
      {value === DIREZ && <Building2 className="h-3.5 w-3.5 text-sky-300" />}{value === DIREZ ? DIREZ_NAME : label || "Partner"}
      <button type="button" onClick={() => onPick(null)} className="text-neutral-400 hover:text-red-400" data-testid={`${testid}-clear`} title="Rimuovi abbinamento"><X className="h-3.5 w-3.5" /></button>
    </span>
  );
  return (
    <div className="relative flex flex-wrap items-center gap-2">
      {allowDirez && <button type="button" onClick={() => onPick(DIREZ)} title="Associa alla Divisione Impianti Torri (direzionale)" data-testid={`${testid}-direz`}
        className="inline-flex items-center gap-1 rounded-full border border-sky-500/40 px-3 py-1 text-xs text-sky-300 transition-colors hover:bg-sky-500/10"><Building2 className="h-3.5 w-3.5" />Divisione Torri</button>}
      <label className="flex items-center gap-2 rounded-full border border-neutral-800 px-3 py-1 text-xs">
        <Search className="h-3.5 w-3.5 text-neutral-500" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca Partner…" className="w-40 bg-transparent text-white outline-none placeholder:text-neutral-600" data-testid={`${testid}-input`} />
      </label>
      {!!res.length && (
        <div className="absolute right-0 top-full z-50 mt-1 max-h-56 w-72 overflow-y-auto rounded-lg border border-neutral-800 bg-neutral-950 shadow-xl">
          {res.map((p) => (
            <button key={p.id} type="button" onClick={() => { onPick(p.id); setQ(""); }} data-testid={`${testid}-opt-${p.id}`}
              className="block w-full px-3 py-2 text-left text-xs text-white hover:bg-neutral-900">{p.name} <span className="text-neutral-500">{[p.city, p.province].filter(Boolean).join(" ")}</span></button>
          ))}
        </div>
      )}
    </div>
  );
}
